/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { useEffect, useState } from "react";
import docAPI from "api";
import { scrollIntoView, getTopElementAndOffsetInViewport } from "api/DxAPI";

const NavigationSync = ({ pageIndex, yInPDF, scrollToPDFLocation }) => {
  const [htmlElementId, setHtmlElementId] = useState(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    docAPI.getHtmlLocationForDocPoint(pageIndex, 0, yInPDF).then(resp => {
      if (resp && resp.data) {
        setOffset(resp.data.offset);
        setHtmlElementId(resp.data.elementID);
      }
    });
    return () => {
      const { elementId, offset } = getTopElementAndOffsetInViewport();
      docAPI.getDocPointForHtmlLocation(elementId, offset).then(resp => {
        if (resp && resp.data) {
          scrollToPDFLocation(resp.data);
        }
      });
    };
  }, []);

  useEffect(() => {
    if (htmlElementId) {
      scrollIntoView(htmlElementId, offset);
    }
  }, [htmlElementId]);

  return null;
};

export default NavigationSync;
